<template>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <v-container v-else>
        <v-row v-if="!isPDF">
            <v-col>
                <v-alert outlined type="warning">There is no preview for this document type, please download it to view.</v-alert>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <pdf :src="filePath" 
                    @num-pages="numPages = $event"
                    :page="page"></pdf>
            </v-col>
            <v-col cols="12" class="text-center">
                <v-btn fab 
                    @click="prevPage"
                    small>
                    <v-icon dark>
                        mdi-chevron-left
                    </v-icon>
                </v-btn>
                {{ page }}/{{ numPages }}
                <v-btn fab 
                    @click="nextPage"
                    small>
                    <v-icon dark>
                        mdi-chevron-right
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import pdf from 'vue-pdf'

export default {
    components:{
        pdf
    },
    props:{
        filePath:{
            type:String,
            default:""
        },
        loading:{
            type:Boolean,
            default:true
        },
        isPDF:{
            type:Boolean,
            default:true
        }
    },
    data(){
        return{
            numPages:0,
            page:1
        }
    },
    methods:{
        prevPage() {
        if (this.page != 1) {
            this.page = this.page - 1;
        }
    },
 
        nextPage() {
        if (this.page != this.numPages) {
            this.page = this.page + 1;
        }
    }
    }
}
</script>
